"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetUserAttendanceQuery = exports.AttendanceCreateDto = exports.AttendanceDto = exports.ByAttendanceAndOrganizationDto = void 0;
const general_dto_1 = require("../../dto/general.dto");
const organization_dto_1 = require("../../organization/dto/organization.dto");
const enums_service_1 = require("../../services/enums.service");
const attendance_enums_1 = require("../types/attendance.enums");
class ByAttendanceAndOrganizationDto extends organization_dto_1.ByOrganizationIdDto {
}
exports.ByAttendanceAndOrganizationDto = ByAttendanceAndOrganizationDto;
class AttendanceDto {
}
exports.AttendanceDto = AttendanceDto;
class AttendanceCreateDto {
}
exports.AttendanceCreateDto = AttendanceCreateDto;
class GetUserAttendanceQuery extends general_dto_1.PaginationQuery {
    constructor() {
        super(...arguments);
        this.sortBy = attendance_enums_1.AttendanceSortByEnum.CHECKIN_DATE;
        this.order = enums_service_1.OrderByEnum.DESC;
    }
}
exports.GetUserAttendanceQuery = GetUserAttendanceQuery;
//# sourceMappingURL=attendance.dto.js.map